<script setup>
  const props = defineProps({
    fighter: Object,
    winner: Boolean,
    inWhiteCorner: Boolean,
    largeLabel: Boolean,
    extraLargeLabel: Boolean,
    noGradientMobile: Boolean,
    forceActive: Boolean,
  });
</script>

<!----------------------------------------------------------------------------->

<template>
  <FighterThumbnail
    :fighter="fighter"
    :inactive="fighter ? (forceActive ? false : !winner) : false"
    :noGradientMobile="noGradientMobile"
    :class="{ inWhiteCorner, largeLabel, extraLargeLabel, win: winner }"
  />
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .img-wrapper {
    &.win {
      &.largeLabel {
        &:after {
          font-size: px(24);
          padding: px(11) px(26) px(7) px(27);

          @include break-medium {
            font-size: px(16);
            padding: px(8) px(19) px(4) px(20);
          }
        }
      }

      &.extraLargeLabel {
        &:after {
          font-size: px(30);
          padding: px(13) px(32) px(7) px(33);

          @include break-medium {
            font-size: px(16);
            padding: px(8) px(19) px(4) px(20);
          }
        }
      }

      &:after {
        @include heroic-bold(px(20));

        content: 'win';
        position: absolute;

        z-index: 2;

        padding: px(10) px(24) px(6) px(25);

        background-color: $red;

        bottom: 0;
        left: 0;

        @include break-medium {
          font-size: px(16);
          padding: px(8) px(19) px(4) px(20);
        }
      }
    }

    &.inWhiteCorner {
      &:after {
        left: auto;
        right: 0;
      }
    }
  }
</style>
